import { supabase } from '../config/supabase';

const adminEmail = 'alex@optimalmarketing.io';
const adminPassword = 'Soelesabe4$';

export const createAdminUser = async () => {
  try {
    // Check if the admin user already exists
    const { data: users, error: listError } = await supabase.auth.admin.listUsers();
    if (listError) throw listError;
    
    const adminExists = users.users.some(user => user.email === adminEmail);

    if (adminExists) {
      console.log('Admin user already exists.');
      return;
    }

    // If admin does not exist, create it
    const { data, error } = await supabase.auth.signUp({
      email: adminEmail,
      password: adminPassword,
    });

    if (error) {
      console.error('Error creating admin user:', error);
      throw error;
    }

    if (data) {
      console.log('Admin user created successfully:', data);
    }
  } catch (error) {
    console.error('An unexpected error occurred during admin user creation:', error);
  }
};

export const signInAsAdmin = async () => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: adminEmail,
    password: adminPassword,
  });

  if (error) {
    console.error('Error signing in as admin:', error);
    throw error;
  }

  return data;
};